import { createGlobalStyle } from "styled-components"
import { ButtonStyle } from "~theme/mixins"

const GlobalStyle = createGlobalStyle`
  ${ButtonStyle}
`

export default GlobalStyle
